module.exports = __webpack_public_path__ + "assets/img/asic_jungle_logo.6800369d.png";